import { TrackingVendor } from '../types';
import { gainsight } from '../trackers';

class Tracker {
  static send = (
    trackEvent: string,
    trackData = {},
    tracker: TrackingVendor = 'all'
  ) => {
    switch (tracker) {
      case 'mixpanel':
        break;
      case 'gainsight': {
        gainsight.track(trackEvent, trackData);
        break;
      }
      default: {
        // defaults to calling all tracking vendors unless specified //
        gainsight.track(trackEvent, trackData);
        break;
      }
    }
  };
}

export default Tracker;
